export function escapeHtml(value: unknown): string {
  return String(value ?? "").replace(
    /[&<>"]/g,
    (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] ?? c,
  );
}

export function formatDuration(seconds: number | null): string {
  if (seconds == null) return "ongoing";
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}m`;
  const h = Math.floor(seconds / 3600);
  const m = Math.round((seconds % 3600) / 60);
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

export function platformLabel(platform: string): string {
  return platform === "shared" ? "All" : platform.charAt(0).toUpperCase() + platform.slice(1);
}

export function incidentNumber(id: string): string {
  return `INC-${id.slice(0, 8).toUpperCase()}`;
}
